import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SunCenterPrintingBrowserService } from './services/sun-center/sun-center-printing.browser.service';
import { SunCenterPrintingServerService } from './services/sun-center/sun-center-printing.server.service';
import { SunCenterPrintingService } from './services/sun-center/sun-center-printing.service';

export function provideSunCenterPrinting(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: SunCenterPrintingService, useClass: SunCenterPrintingBrowserService }]);
}

export function provideSunCenterPrintingServer(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: SunCenterPrintingService, useClass: SunCenterPrintingServerService }]);
}
